/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionSecurityGroupResponse
 */
export interface PermissionSecurityGroupResponse {
    /**
     * 
     * @type {any}
     * @memberof PermissionSecurityGroupResponse
     */
    permissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionSecurityGroupResponse
     */
    securityGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionSecurityGroupResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the PermissionSecurityGroupResponse interface.
 */
export function instanceOfPermissionSecurityGroupResponse(value: object): value is PermissionSecurityGroupResponse {
    return true;
}

export function PermissionSecurityGroupResponseFromJSON(json: any): PermissionSecurityGroupResponse {
    return PermissionSecurityGroupResponseFromJSONTyped(json, false);
}

export function PermissionSecurityGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionSecurityGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionId': json['permissionId'] === undefined ? undefined : json['permissionId'] === null ? null : json['permissionId'],
        'securityGroupId': json['securityGroupId'] === undefined ? undefined : json['securityGroupId'] === null ? null : json['securityGroupId'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
    };
}

export function PermissionSecurityGroupResponseToJSON(json: any): PermissionSecurityGroupResponse {
    return PermissionSecurityGroupResponseToJSONTyped(json, false);
}

export function PermissionSecurityGroupResponseToJSONTyped(value?: PermissionSecurityGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionId': value['permissionId'],
        'securityGroupId': value['securityGroupId'],
        'displayName': value['displayName'],
    };
}

